import enTranslations from './en';
import nlTranslations from './nl';
import frTranslations from './fr';


const translations = new Map();
translations.set("en", enTranslations);
translations.set("fr", frTranslations);
translations.set("nl", nlTranslations);

export const getTranslations = (locale: string) => {
    if (translations.has(locale)) {
        return translations.get(locale);
    } 
    
    return enTranslations;
}